import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MarkdownContent } from '../components/MarkdownContent';
import { FloatingContact } from '../components/FloatingContact';
import { getLegalPage } from '../api/api';
import { useSeo } from '../hooks/useSeo';

export const LegalPage = () => {
  // Les routes sont explicites (/cgv, /confidentialite…) plutôt que
  // paramétrées : le slug se déduit donc du chemin.
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+|\/+$/g, '');
  const [page, setPage] = useState(null);
  const [etat, setEtat] = useState('chargement');

  useEffect(() => {
    let actif = true;
    setEtat('chargement');
    getLegalPage(slug)
      .then((data) => actif && (setPage(data), setEtat('ok')))
      .catch(() => actif && setEtat('erreur'));
    window.scrollTo(0, 0);
    return () => {
      actif = false;
    };
  }, [slug]);

  useSeo({
    title: page?.title ? `${page.title} | NETTO+` : undefined,
    path: `/${slug}`,
  });

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 w-full">
        {etat === 'chargement' && (
          <div className="animate-pulse space-y-4" aria-label="Chargement">
            <div className="h-8 bg-gray-200 rounded w-2/3" />
            <div className="h-4 bg-gray-100 rounded w-full" />
            <div className="h-4 bg-gray-100 rounded w-5/6" />
            <div className="h-4 bg-gray-100 rounded w-4/6" />
          </div>
        )}

        {etat === 'erreur' && (
          <div className="text-center py-12">
            <h1 className="text-2xl font-bold text-gray-900 mb-3">Page introuvable</h1>
            <p className="text-gray-600 mb-6">Cette page n'existe pas ou n'est plus disponible.</p>
            <Link to="/" className="text-blue-600 underline">
              Retour à l'accueil
            </Link>
          </div>
        )}

        {etat === 'ok' && page && (
          <article>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">{page.title}</h1>
            {page.updated_at && (
              <p className="text-sm text-gray-500 mb-8">
                Dernière mise à jour :{' '}
                {new Date(page.updated_at).toLocaleDateString('fr-BE', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })}
              </p>
            )}
            <MarkdownContent content={page.content} />
          </article>
        )}
      </main>
      <Footer />
      <FloatingContact />
    </div>
  );
};

export default LegalPage;
